export default __webpack_public_path__ + "static/media/bus-trv-10.2a3b5f51.png";